import React, { Component } from 'react';
import './index.css';
import { getWeatherData } from '../../services/weather';
import partnerService from '../../services/partner';
import _groupBy from 'lodash.groupby'

/*
  partner type
    transport
    attractions
    entertaiment
    restaurants
*/

export default class Partners extends Component {
  state = {
    names: {
      'transport': 'Cum ajungi in centru',
      'attraction': 'Vizitat',
      'entertaiment': 'Entertaiment',
      'restaurant': 'Restaurante'
    }
  };

  componentDidMount() {
    partnerService.data().then(this.savePartners.bind(this));
  }

  savePartners(partners) {
    this.setState({
      partners: partners
    });
  }

  renderPartners(partners) {
    const groupedPartners = _groupBy(partners || [], 'type');

    return Object.keys(groupedPartners)
    .map(key => {
      const p = groupedPartners[key];
      const content = (p || []).map((item, index) => (
        <a className={`col-md-4 ${index !== 0 ? 'offset-md-1': ''}`} href={item.link} style={{backgroundImage: `url('${item.image}')`}}>
          <h5>{item.name}</h5>
        </a>
      ));

      return (
        <div className='viewsIasi__partner'>
          <div className='row'>
          <h4 className='viewsIasi__partner__title'>{this.state.names[key] || ''}</h4>
          </div>

          <div className='row'>
            {content}
          </div>
        </div>
      );
    });
  }

  render() {
    const renderedPartners = this.renderPartners(this.state.partners);

    return (
      <div>
        {renderedPartners}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partners/index.js